module.exports = __webpack_public_path__ + "media/Podcast_CF01_33110059_Valores del ser humano.8521bbf6.wav";